import * as React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { AnimatedMenuItemRow } from '../components/animated-elements/AnimatedMenuItemRow';
import { useScroll, useTransform } from 'motion/react';
import { useRef } from 'react';
import { nutritionalData } from '../content/menu-items';
import CharcoalBG from '../assets/charcoal-bed.webp'
import { ScrollContext } from '../features/scroll-context/ScrollContext';
import { ParallaxedBg } from '../components/animated-elements/ParallaxBg';
import {motion} from 'motion/react'
import GrilledMeatTitle from '../assets/grilled-meats-title.webp'
import SmokedMeatTitle from '../assets/smoked-meats-title.webp'
import SidesTitle from '../assets/sides-title.webp'
import OtherEntreesTitle from '../assets/other-entrees-title.webp'

function ItemContainer({ children, parentRef, sectionTitle }: { children: React.ReactNode, parentRef: React.RefObject<HTMLDivElement>, sectionTitle: React.ReactNode }) {

  const { scrollYProgress } = useScroll({
    target: parentRef,
    offset: ['start start', 'end end']
  })

  return (
    <ScrollContext.Provider value={{ progress: scrollYProgress }}>
      <Grid container position="relative" justifyContent="center" alignItems="center">
        <Grid position="sticky" item top={{ xs: "50px", md: "50px" }} mb="40px" height="30vh" xs={12}>
          {sectionTitle}
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </ScrollContext.Provider>
  )
}

export default function MenuPage() {
  const smokedMeatContainer = useRef(null);
  const grilledMeatContainer = useRef(null);
  const otherEntreesContainer = useRef(null);
  const sidesContainer = useRef(null);
  const mainContainer = useRef(null)

  const { scrollYProgress } = useScroll({
    target: mainContainer,
    offset: ['start start', 'end end']
  })
  const y = useTransform(scrollYProgress, [0, 1], ["10vh", "-10vh"]);

  return (
    <Box sx={{ pt: '40vh', pb: '50vh', position: 'relative' }} ref={mainContainer}>
      <ParallaxedBg bgY={y} backgroundImage={CharcoalBG}/>
      
      <Box
        ref={smokedMeatContainer}
        position='relative'
        top='50px'
        sx={{
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '1200px',
          m: 'auto',
          mt: '100px'
        }}
      >
        <ItemContainer
          parentRef={smokedMeatContainer}
          sectionTitle={<motion.img alt='Title Smoked Meats' src={SmokedMeatTitle} style={{width: '60vw', maxWidth: '300px', filter: 'drop-shadow(0px 0px 2px white)'}}/>}
        >
          {
            nutritionalData.smokedMeatsData.map((item, index) => (
              <AnimatedMenuItemRow
                key={index}
                index={index}
                {...item}
                targetScale={1 - ((nutritionalData.smokedMeatsData.length - index) * 0.05)}
                range={[index / nutritionalData.smokedMeatsData.length, 1]}
              />
            ))
          }
        </ItemContainer>
      </Box>
      <Box
        ref={grilledMeatContainer}
        position='relative'
        top='50px'
        sx={{
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '1200px',
          m: 'auto',
          mt: '150px'
        }}
      >
        <ItemContainer
          parentRef={grilledMeatContainer}
          sectionTitle={<motion.img alt='Title Grilled Meats' src={GrilledMeatTitle} style={{width: '60vw', maxWidth: '300px', filter: 'drop-shadow(0px 0px 2px white)'}}/>}
        >
          {
            nutritionalData.grilledMeatsData.map((item, index) => (
              <AnimatedMenuItemRow
                key={index}
                index={index}
                {...item}
                targetScale={1 - ((nutritionalData.grilledMeatsData.length - index) * 0.05)}
                range={[index / nutritionalData.grilledMeatsData.length, 1]}
              />
            ))
          }
        </ItemContainer>

      </Box>
      <Box
        ref={otherEntreesContainer}
        position='relative'
        top='50px'
        sx={{
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '1200px',
          m: 'auto',
          mt: '100px'
        }}
      >
        <ItemContainer
          parentRef={otherEntreesContainer}
          sectionTitle={<motion.img alt='Title Other Entrees' src={OtherEntreesTitle} style={{width: '60vw', maxWidth: '300px', filter: 'drop-shadow(0px 0px 2px white)'}}/>}
        >
          {
            nutritionalData.otherEntreesData.map((item, index) => (
              <AnimatedMenuItemRow
                key={index}
                index={index}
                {...item}
                targetScale={1 - ((nutritionalData.otherEntreesData.length - index) * 0.05)}
                range={[index / nutritionalData.otherEntreesData.length, 1]}
              />
            ))
          }
        </ItemContainer>
      </Box>
      <Box
        ref={sidesContainer}
        position='relative'
        top='50px'
        sx={{
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
          maxWidth: '1200px',
          m: 'auto',
          mt: '100px'
        }}
      >
        <ItemContainer
          parentRef={sidesContainer}
          sectionTitle={<motion.img alt='Title Sides' src={SidesTitle} style={{width: '60vw', maxWidth: '300px', filter: 'drop-shadow(0px 0px 2px white)'}}/>}
        >
          {
            nutritionalData.sidesData.map((item, index) => (
              <AnimatedMenuItemRow
                key={index}
                index={index}
                {...item}
                targetScale={1 - ((nutritionalData.sidesData.length - index) * 0.05)}
                range={[index / nutritionalData.sidesData.length, 1]}
              />
            ))
          }
        </ItemContainer>
      </Box>
    </Box>
  );
}
